export function expiredDocument(document, today = new Date()) {
  if (!document.expirationDate) return false;
  const value = String(document.expirationDate);
  const match = value.match(/^(\d{4})-?(\d{2})-?(\d{2})(?:$|T)/);
  if (!match) return false;
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  if (date.getFullYear() !== Number(match[1]) || date.getMonth() !== Number(match[2]) - 1 || date.getDate() !== Number(match[3])) return false;
  return date < new Date(today.getFullYear(), today.getMonth(), today.getDate());
}
